import axios from 'axios'
import store from '~/store'
import router from '~/router'
import Cookies from 'js-cookie'

window.axios = axios;

// Request interceptor
axios.interceptors.request.use(request => {
  let token = Cookies.get('token');

  if (token) {
    request.headers.common['Authorization'] = `Bearer ${token}`
  }

  const locale = store.getters['lang/locale'];
  if (locale) {
    request.headers.common['Accept-Language'] = locale
  }

  // request.headers['X-Socket-Id'] = Echo.socketId()

  return request
});

// Response interceptor
axios.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response;
    if (status === 401 && store.getters['auth/check'] && error.config.url !== '/api/logout') {
      return refreshToken().then((token) => {
        if (token === null) {
          router.push({ name: 'login' });
          return Promise.reject(error);
        }
        error.config.headers['Authorization'] = 'Bearer ' + token;
        error.config.baseURL = undefined;
        return axios.request(error.config);
      });
    }
    return Promise.reject(error);
  }
);

function refreshToken() {
  if (store.getters['auth/isRefreshing']) {
    setTimeout(() => {
      store.dispatch('auth/setRefreshingState', false);
    }, 10000);
    return store.getters['auth/refreshingCall'];
  }

  store.dispatch('auth/setRefreshingState', true);

  const refreshingCall = axios.post('/api/refresh_token', {
    'token': store.getters['auth/token']
  }).then(async (response) => {
    let token = response.data.token ? response.data.token : null;

    if (token === null)
      await store.dispatch('auth/logout');

    await store.dispatch('auth/saveToken', { token });
    await store.dispatch('auth/setRefreshingState', false);
    await store.dispatch('auth/setRefreshingCall', undefined);

    return Promise.resolve(token);
  });

  store.dispatch('auth/setRefreshingCall', refreshingCall);

  return refreshingCall;
}



// WEBPACK FOOTER //
// ./resources/js/plugins/axios.js